import fonts from 'styles/fonts';
import styled from '@emotion/styled';
import { Theme } from 'widget/styles/themes';

type Props = {
  'data-test'?: string;
  selected?: boolean;
};

const Text = styled('p')<Props>(
  ({ selected = false, theme }: Props & { theme: Theme }) => ({
    color: selected ? theme.activeText : 'inherit',
    fontSize: fonts.size['14'],
    lineHeight: 1.3,
    paddingBottom: '0.5rem',
    paddingTop: '1rem',
  }),
);

export default Text;
